// extracted by mini-css-extract-plugin
export default {"icon":"FullScreenToggle_icon__dmRcc","withRightPanel":"FullScreenToggle_withRightPanel__nCXZB"};